import React from 'react';
import { Link } from 'react-router-dom';

const IndustrySectorsSection = ({ assessmentCounts, loading }) => (
  <div className="py-12 bg-white dark:bg-gray-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">
          Serving Diverse Industrial Sectors
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-4xl mx-auto">
          Our assessments are customised for the unique energy profiles of different manufacturing and
          industrial sectors.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {/* Food & Beverage Processing */}
        <Link to="/food-beverage" className="relative group cursor-pointer block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://images.unsplash.com/photo-1652211955967-99c892925469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxmb29kJTIwcHJvY2Vzc2luZ3xlbnwwfHx8fDE3NTcxMzQ4OTF8MA&ixlib=rb-4.1.0&q=85"
              alt="Food & Beverage Processing"
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity duration-300"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-xl font-bold">Food & Beverage</h3>
              <p className="text-white text-sm mt-2 opacity-90">
                {loading
                  ? '...'
                  : `${assessmentCounts['Food & Beverage']?.toLocaleString() || '1,539'} assessments`}
              </p>
            </div>
          </div>
        </Link>

        {/* Plastics & Packaging */}
        <Link to="/plastics-packaging" className="relative group cursor-pointer block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&cs=tinysrgb&w=800"
              alt="Plastics & Packaging"
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity duration-300"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-xl font-bold">Plastics & Packaging</h3>
              <p className="text-white text-sm mt-2 opacity-90">
                {loading
                  ? '...'
                  : `${assessmentCounts['Plastics & Packaging']?.toLocaleString() || '1,058'} assessments`}
              </p>
            </div>
          </div>
        </Link>

        {/* Metal Products */}
        <Link to="/metal-products" className="relative group cursor-pointer block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://images.unsplash.com/photo-1681399577093-e57cea722a9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzl8MHwxfHNlYXJjaHwxfHxtZXRhbCUyMHdlbGRpbmd8ZW58MHx8fHwxNzU3MTM1MDk5fDA&ixlib=rb-4.1.0&q=85"
              alt="Metal Products"
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity duration-300"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-xl font-bold">Metal Products</h3>
              <p className="text-white text-sm mt-2 opacity-90">
                {loading
                  ? '...'
                  : `${assessmentCounts['Metal Products']?.toLocaleString() || '1,141'} assessments`}
              </p>
            </div>
          </div>
        </Link>

        {/* Chemicals & Pharmaceuticals */}
        <Link to="/chemicals-pharmaceuticals" className="relative group cursor-pointer block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjaGVtaWNhbCUyMHBsYW50fGVufDB8fHx8MTc1NzEzNTExM3ww&ixlib=rb-4.1.0&q=85"
              alt="Chemicals & Pharmaceuticals"
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity duration-300"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-xl font-bold">Chemicals & Pharmaceuticals</h3>
              <p className="text-white text-sm mt-2 opacity-90">
                {loading
                  ? '...'
                  : `${
                      assessmentCounts['Chemicals & Pharmaceuticals']?.toLocaleString() || '748'
                    } assessments`}
              </p>
            </div>
          </div>
        </Link>

        {/* Mining & Primary Metals */}
        <Link to="/mining-primary-metals" className="relative group cursor-pointer block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://images.unsplash.com/photo-1697163505858-9a5ec2c79eb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtaW5pbmclMjBmdXJuYWNlfGVufDB8fHx8MTc1NzEzNTEyN3ww&ixlib=rb-4.1.0&q=85"
              alt="Mining & Primary Metals"
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity duration-300"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-xl font-bold">Mining & Primary Metals</h3>
              <p className="text-white text-sm mt-2 opacity-90">
                {loading
                  ? '...'
                  : `${
                      assessmentCounts['Mining & Primary Metals']?.toLocaleString() || '313'
                    } assessments`}
              </p>
            </div>
          </div>
        </Link>

        {/* Facilities Management */}
        <Link to="/facilities-management" className="relative group cursor-pointer block">
          <div className="overflow-hidden rounded-2xl">
            <img
              src="https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBjcmFuZXxlbnwwfHx8fDE3NTcxMzUxNDN8MA&ixlib=rb-4.1.0&q=85"
              alt="Facilities Management"
              className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-50 transition-opacity duration-300"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-white text-xl font-bold">Facilities Management</h3>
              <p className="text-white text-sm mt-2 opacity-90">
                {loading
                  ? '...'
                  : `${
                      assessmentCounts['Facilities Management']?.toLocaleString() || '27'
                    } assessments`}
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  </div>
);

export default IndustrySectorsSection;


